import type { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { featureFlagsQueryKey } from "./feature-flags.keys";

export const usePrefetchFeatureFlags = () => {
	const { get } = useRequest();

	const { isLoading } = useQuery({
		queryKey: featureFlagsQueryKey(),
		queryFn: async () => await get<Dtos.FeatureFlag.GetAll.Response>("/v2/feature-flags"),
		staleTime: 5 * 60 * 1000,
	});

	return { isLoading };
};
